export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-100px.jpg.e44928a2.webp";